import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Content from "../common/Content";
import { scrollToTop } from "../common/GeneralMethod";
import { useLoading } from "../hooks/useLoading";
import Footer from "../common/Footer";
import Header from "../common/Header";
import LogoContent from "../common/LogoContent";

const RefundPolicy = ({Header}) => {
  return (
    <div>
      {/* Header */}
      {Header!=="No" ? <header className="navbar-light header-sticky">
        <nav className="navbar navbar-expand-xl">
          <div className="container">
            <LogoContent />
          </div>
        </nav>
      </header>:null}

      <main>
        <div className="main-content my-5 py-3">
          <div className="refundPolicy">
            <div className="container">
              


              {/* New Extended Policy Content */}
              <h4 className="mb-3">Cancellation and Refund Policy</h4>
              <h6 className="mb-3">
                {"updated Date: 26 Dec 2024"}
              </h6>
              <h6>Cancellation Policy</h6>
              <ul>
                <li>
                  <strong>1.1</strong> You may cancel your booking anytime before your scheduled pick-up by calling our 24x7 Customer Care helpline at 9997325252. If cancellation occurs after the driver and/or car details are provided, a cancellation fee will apply.
                </li>
                <li>
                  <strong>1.2</strong> No cancellation fee will be charged unless Cabkro confirms the cancellation under the terms of use and this policy.
                </li>
                <li>
                  <strong>1.3 Cancellation fees:</strong>
                  <ul>
                    <li>1.3.1 Cancellations are free of charge if the driver or car details have not been provided.</li>
                    <li>1.3.2 If cancellation occurs after the driver and/or car details are provided, you will forfeit the entire advance payment made for the booking.</li>
                    <li>1.3.3 Drivers may cancel a ride if they have waited 45 minutes at the pickup location, if incorrect pickup details are provided, or if you are unreachable. You may be charged either the full advance payment or a fee based on the wait time.</li>
                    <li>1.3.4 In case of cancellations due to unavoidable external factors such as natural disasters, strikes, or other force majeure events that close roads, a voucher for the full advance payment will be issued, valid for future use.</li>
                  </ul>
                </li>
              </ul>

              <h6>Refund Policy</h6>
              <ul>
                <li>
                  <strong>2.1</strong> Refunds will be processed as per the cancellation and refund policy and may take 7 to 10 business days to reflect in your account. Cabkro is not responsible for losses due to incorrect banking details provided by you.
                </li>
                <li>
                  <strong>2.2</strong> Vouchers without expiration, valid for future use, will be issued at Cabkro’s discretion in the following cases:
                  <ul>
                    <li>2.2.1 If the allocated driver cancels at the last minute and Cabkro cannot arrange another ride in a reasonable time, you will receive a voucher for the full advance payment.</li>
                    <li>2.2.2 If the car breaks down during the trip and cannot be fixed within a reasonable time, you will receive a voucher for the full advance payment.</li>
                    <li>2.2.3 Cancellations due to unavoidable external factors such as natural disasters, strikes, or other force majeure events will result in a voucher for the full advance payment.</li>
                    <li>2.2.4 If you need to change the car type, adjust the trip duration, or correct the itinerary, inform Cabkro in advance. Upon confirmation, a voucher for the full advance payment will be issued.</li>
                  </ul>
                </li>
                <li>
                  <strong>2.3</strong> Cabkro is not responsible for refunds or vouchers if you give money or goods to the driver outside of what is mentioned in the invoice. Cabkro is not liable for any damages arising from such actions.
                </li>
                <li>
                  <strong>2.4</strong> Cabkro is not responsible for any loss or damage during the ride caused by the driver. However, Cabkro will reasonably assist you in recovering your loss or damage.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>

      {/* <Footer /> */}
      {/* <BackToTop /> */}
    </div>
  );
};

export default RefundPolicy;
